<template>
    <div ref="formulaContainer"
        class="latex-formula"
        :style="{ color: `var(--${fontClass})` }"></div>
</template>

<script>
import katex from 'katex';

export default {
    name: 'mead-formula',
    props: {
        /**
         * The raw LaTeX string to render with KaTeX. Required.
         */
        formula: {
            type: String,
            required: true
        },
        /**
         * Whether to render the formula in KaTeX's block "display" mode (larger,
         * centered) rather than inline mode. Passed directly to KaTeX's
         * `displayMode` option.
         */
        displayMode: {
            type: Boolean,
            default: true
        },
        /**
         * Size of the rendered formula. One of "xs", "s", "m", "l", "xl", mapped
         * internally to a KaTeX size command (e.g. "m" -> `\normalsize`).
         */
        uiSize: {
            type: String,
            default: 'm',
        },
        /**
         * Name (without the `--` prefix) of the CSS custom property used for the
         * formula's text color, applied as `color: var(--{fontClass})`.
         */
        fontClass: {
            type: String,
            default: 'c-txt'
        }
    },
    mounted() {
        this.renderFormula();
    },
    watch: {
        formula() { this.renderFormula(); },
        uiSize() { this.renderFormula(); },
        displayMode() { this.renderFormula(); },
        fontClass() { this.renderFormula(); }
    },
    methods: {
        renderFormula() {
            let latexSize = '\\normalsize';
            switch (this.uiSize) {
                case 'xs': latexSize = '\\tiny'; break;
                case 's':  latexSize = '\\small'; break;
                case 'm':  latexSize = '\\normalsize'; break;
                case 'l':  latexSize = '\\large'; break;
                case 'xl': latexSize = '\\huge'; break;
            }

            if (this.$refs.formulaContainer) {
                try {
                    // Look how clean this is now. No complex HTML injection strings needed.
                    katex.render(
                        `${latexSize} ${this.formula}`,
                        this.$refs.formulaContainer,
                        {
                            displayMode: this.displayMode,
                            throwOnError: false
                        }
                    );
                } catch (error) {
                    console.error('LaTeX rendering error:', error);
                }
            }
        }
    }
};
</script>